const config = {
	pageSize: 25,
	topLevelMargin: 20,
	scrollMargin: 50,
	pageName: "EmployeeGoals",
	dateFormat: "MMM D, YYYY",
	baseURL: "/employee/goals/",
	goalURL: "/goal/",
	pageTitle: "Employee Goal List",
	queryParams: [
		{
			param: "name",
			type: "",
		},
		{
			param: "pickedAssignees",
			type: "userIDs",
		},
		{
			param: "createdAfterDate",
			type: "date",
		},
		{
			param: "createdBeforeDate",
			type: "date",
		},
		{
			param: "dueAfterDate",
			type: "date",
		},
		{
			param: "dueBeforeDate",
			type: "date",
		},
		{
			param: "category",
			type: "goalCategory",
		},
		{
			param: "status",
			type: "multiSelect",
		},
		{
			param: "transparency",
			type: "multiSelect",
		},
		{
			param: "outlook",
			type: "goalOutlook",
		},
		{
			param: "sharedOnly",
			type: "checkbox",
		},
		{
			param: "unseenUpdatesOnly",
			type: "checkbox",
		},
		{
			param: "alignment",
			type: "goalPicker",
		},
		{
			param: "currentSortName",
			type: "string",
		},
		{
			param: "currentSortDirection",
			type: "string",
		},
		{
			param: "currentPage",
			type: "number",
		},
		{
			param: "search",
			type: "string",
		},
	],
	pageFiltersLookup: [
		"name",
		"status",
		"transparency",
		"createdDateLessThan",
		"createdDateGreaterThan",
		"dueDateLessThan",
		"dueDateGreaterThan",
		"outlookID",
		"assigneeID",
		"categoryID",
		"ancestors.id",
		"hasUpdates",
		"sharedOnly",
		"currentSortName",
		"currentSortDirection",
		"currentPage",
		"search",
	],
};

export default config;
